// How long a deleted thing stays recoverable, in days.
//
// W39.70. These numbers were restated — in five components, in two error
// messages the server sends, and in a pair of tests that pinned the wrong one.
// W39.54 widened wishes, anniversaries and albums from 7 days to 30 and the
// constants moved with it; the sentences did not. The worst of them was the
// server's own 410 body, which is the line a person reads at the exact moment
// they find they cannot get something back.
//
// W39.78. The diary was the last holdout at 7. The file said so on purpose —
// "the diary stays at 7 … because those were never changed" — and the note was
// honest about the reason, which is what made it worth reading: an omission, not
// a decision. Four soft-deletable modules answering 「我還有多少時間」 differently
// is the same defect W39.54 fixed three of, so all four are 30 now. That
// supersedes W0's locked Q13 (7 days) and ADR-0087 records it. The dissolved
// pair stays at 7 — it is a different kind of window and was never in this set.
//
// Each value is the backend's, named at the definition. These are retyped
// rather than fetched — the trash APIs return a per-row `days_left` computed
// server-side (see `TrashList`), which is what the UI actually shows for a row
// already in the trash; these constants are for the sentences that appear
// *before* anything is deleted, where there is no row to ask about.
//
// Backend sources:
//   diary        app.modules.diary.service.retention.DIARY_RETENTION_DAYS
//   wish         app.modules.wishlist.service.retention.WISH_RETENTION_DAYS
//   anniversary  app.modules.anniversary.service.retention.ANNIVERSARY_RETENTION_DAYS
//   album        app.modules.album.service.retention.ALBUM_RETENTION_DAYS
//   calendar     app.modules.calendar.service.crud.restore_event — `deleted_at +
//                timedelta(days=7)`, written inline (W39.1 R1 / ADR-0080). Named
//                here so the calendar's copy is derived like the rest, and so
//                `retentionWindows.test.ts` can check it like the rest.
//   pair         W2 §4.4 — soft-dissolved pairs keep their rows 7 days
export const DIARY_RESTORE_DAYS = 30;
export const WISH_RESTORE_DAYS = 30;
export const ANNIVERSARY_RESTORE_DAYS = 30;
export const ALBUM_RESTORE_DAYS = 30;
export const CALENDAR_RESTORE_DAYS = 7;
export const PAIR_REPAIR_DAYS = 7;

/** 「N 天內可以還原」 — the shape every restore sentence uses. */
export const restoreSentence = (days: number): string => `${days} 天內可以還原`;

/** 「N 天保留期: …」 — the dissolve banner. */
export const retentionPhrase = (days: number): string => `${days} 天保留期`;
